import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0 text-end",
  style: {"word-break":"break-word !important"}
}, " Số lượng ", -1)
const _hoisted_3 = { class: "mb-0 text-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0 text-end",
  style: {"word-break":"break-word !important"}
}, " Đơn giá ", -1)
const _hoisted_5 = { class: "text-end mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0 text-end",
  style: {"word-break":"break-word !important"}
}, " Thành tiền ", -1)
const _hoisted_7 = { class: "text-end mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DivCol, { cols: 1 }),
    _createVNode(_component_DivCol, { cols: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: true,
          "cell-class-name": _ctx.isTextDangerColumn,
          "cell-style": {padding: '0', height: '15px'},
          data: _ctx.items,
          "empty-text": "Chưa có vật tư trong biên bản",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "TT",
              width: "50"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.$index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_word_break_column, {
              "header-title": "Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa",
              property: "ten_vat_tu"
            }),
            _createVNode(_component_el_table_column, {
              label: "Mã số",
              width: "80"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Đơn vị tính",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Trạng thái",
              width: "90"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { width: "80" }, {
              header: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.pivot.so_luong)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Đơn giá",
              width: "80"
            }, {
              header: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_5, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.donGiaDisplay(scope.$index)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { width: "95" }, {
              header: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.thanhTienDisplay(scope.$index)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cell-class-name", "data"])
      ]),
      _: 1
    }),
    _createVNode(_component_DivCol, { cols: 1 })
  ]))
}